module.exports = __webpack_public_path__ + "media/icons/i-10-templates-2ca3a2b6.png";